export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10905.bfda1b71.jpg";